/* eslint-disable prettier/prettier */
import SendIcon from '@material-ui/icons/Send';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import Picker, { Theme, EmojiStyle} from 'emoji-picker-react';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import PollOutlinedIcon from '@material-ui/icons/PollOutlined';
import {
  FaFilePdf,
  FaFileAlt,
  FaFile,
  FaFileVideo,
  FaChevronDown,
  FaArrowCircleUp,
  FaAngleUp,
  FaFileAudio,
  FaImage,
  FaVideo,
} from 'react-icons/fa';
import {
  CreateAttachment,
  MarkMessageRead,
  MarkAllMessageRead,
  ReplyMessage,
  SendMessageUsingContactInformation,
  SendMessageUsingFilter,
  UploadToAws,
} from '../../services/chat';
import Linkify from 'react-linkify';
import {
  getUserGuid,
  getPortalServerIp,
  getIdentificationId,
} from '../../storage';
import {
  autoUrl,
  convertBackendDate,
  getStringDate,
  streamFile,
  getPlainMessageText,
  resolveMessage,
  resolveForward,
} from '../../utils';
import loadingIcon from '../../assets/images/loading.gif';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoneIcon from '@material-ui/icons/Done';
import { TiArrowForward } from 'react-icons/ti';
import Close from '@material-ui/icons/Close';
import './styles.css';
import {
  Content,
  Container,
  SendContent,
  InputContainer,
  MessageContent,
  MessageMarked,
  ButtonClose,
  RepliedMessage,
  ForwardText,
  BottomContent,
  Input,
  AttachmentContainer,
  AttachmentFile,
  Unread,
  ButtonScrollDown,
  DropArea,
  FileDetailsContainer,
  FileName,
  FileTypeSize,
  FilesPreviewContainer,
} from './styles';
import { useLoading } from '../../hooks/loading';
import ActionsMessage from '../../components/actionsmessage';
import { useChatMessages } from '../../hooks/chat';
import TiptapEditor from './TiptapEditor';
import { GetMessagesForConversations } from '../../services/conversations';
import Forward from '../../components/Forward';
import { IconButton, LinearProgress } from '@material-ui/core';
import DialogImage from './DialogImage';
import CreatePollDialog from './CreatePollDialog';
import { useToast } from '../../hooks/toast';
import { AccessTime, CenterFocusStrong } from '@material-ui/icons';
import { BalloonComponent } from '../../components/balloon';
import { useIntl } from 'react-intl';
import { useDropzone } from 'react-dropzone';
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import { REACT_APP_ENABLE_SERVERSENTEVENT } from '../../config';
import { useConversation } from '../../hooks/conversation';
import { useSignalRContext } from '../../contexts/SignalRContext';
import { getE2EEncryptionEnabledFlag } from '../../storage/index';
import { GetStaffInformationForStaffGroup } from '../../services/staff';
import FormatColorTextIcon from '@material-ui/icons/FormatColorText';
import { UpdateMessage } from '../../services/chat';
import MessageEditTextarea from '../../components/MessageEditTextarea';

const MemoPicker = React.memo(Picker);
const Chat = ({ conversationId,selectedConversation }) => {
  const intl = useIntl();
  const { startLoading, loading, stopLoading } = useLoading();
  const { addToast } = useToast(false);
  const [openEmoji, setOpenEmoji] = useState(false);
  // prettier-ignore
  const {
    messages,
    setMessages,
    hasUpdate,
    unreadMessages,
    setUnreadMessages,
    addMessageManually,
    setHasUpdate,//added for SSE update purpose
    encryptChatMessage,
    isLoading,
    encryptAttachment,
    decryptAndCreateBlobUrl,
  } = useChatMessages();
  const [files, setFiles] = useState([]);
  const [pastMessages, setPastMessages] = useState([]);
  const [lastUpdate, setLastUpdate] = React.useState(-1);
  const [selectedMessage, setSelectedMessage] = React.useState();
  const [attSelected, setAttSeleted] = React.useState();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [selectedMessageForward, setSelectedMessageForward] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [more, setMore] = React.useState(false);
  // prettier-ignore
  const [moreMessagesAvailable, setMoreMessagesAvailable] = React.useState(
    true
  );
  const userGuid = getUserGuid();
  const messagesEndRef = useRef(null);
  const messagePastRef = useRef(null);
  const scroll = useRef(null);
  const inputSendText = useRef(null);
  const fileRef = useRef(null);
  const formRef = useRef(null);
  const refBottom = useRef(null);
  const [pbottom, setPBottom] = useState(0);
  const [topS, setTopS] = useState(0);
  const urlDownload = `${getPortalServerIp()}/CareServantAttachments/AttachmentManagerService.svc/DownloadAttachment/${getIdentificationId()}`;
  const [loadingMessages, setLoadingMessages] = useState(true);
  const isFetchingMoreRef = useRef(false);
  const [openPollDialog, setOpenPollDialog] = useState(false);
  const isE2EEnabled = getE2EEncryptionEnabledFlag();

  const {
    conversationDecryptedKey,
    conversationDecryptedIV,
    GetUserConversations,
  } = useConversation();

  const {
    isConnected,
    joinConversation,
    leaveConversation,
    joinedConversationId,
    sendMessageUsingContactInformation_SignalR,
    sendMessageUsingFilter_SignalR,
    markAllMessageRead_SignalR,
    signalRService,
  } = useSignalRContext();
  const activeGuidRef = useRef(conversationId?.Guid);
  activeGuidRef.current = conversationId?.Guid;

  // 1. Join room when selected conversation changes (matches Desktop exactly)
  useEffect(() => {
    const targetGuid = conversationId?.Guid;
    if (targetGuid && isConnected && joinedConversationId !== targetGuid) {
      joinConversation(targetGuid).catch(console.error);
    }
  }, [conversationId?.Guid, isConnected, joinedConversationId, joinConversation]);

  // 2. Only leave room when the Chat component unmounts (closing chat / navigating away)
  useEffect(() => {
    return () => {
      setUnreadMessages([]);
      if (activeGuidRef.current) {
        leaveConversation(activeGuidRef.current).catch(() => {});
      }
    };
  }, [leaveConversation, setUnreadMessages]);

  const [editingMessage, setEditingMessage] = React.useState(null);
  const [editExistingAttachments, setEditExistingAttachments] = React.useState([]);
  const isEditingSaveRef = useRef(false);
  const prevMessageCountRef = useRef(0);
  const prevLastMessageGuidRef = useRef(null);

  useEffect(() => {
    setPastMessages([]);
    setMoreMessagesAvailable(true);
    setTopS(0);

    // 1. Reset TipTap Editor text, preview cards, and state
    inputSendText.current?.clearContent?.();

    // 2. Clear any pending attachments and active quoted reply target
    setFiles([]);
    setSelectedMessage(null);
    setShowFormatToolbar(false);

    // 3. Close edit box and reset edit state when switching conversation
    setEditingMessage(null);
    setEditExistingAttachments([]);
    isEditingSaveRef.current = false;
    prevLastMessageGuidRef.current = null; // 👈 Cleans tracking so newly opened conversation scrolls to bottom

    if (!conversationId?.Broadcast && inputSendText.current) {
      inputSendText.current.focus();
    }
  }, [conversationId?.Guid || conversationId]);

  const submit = useCallback(
    async (event) => {
      if (event) event.preventDefault();
      try {
        const rawHtml = inputSendText.current?.getHTML?.() || '';
        const plainText = (inputSendText.current?.getText?.() || '').trim();

        // Check if there is genuine rich formatting (bold, italic, underline, strike, links, mentions, lists, etc.)
        const isHtmlMessage =
          /<(strong|b|em|i|u|s|strike|del|a|span|code|blockquote|ul|ol|li)/i.test(
            rawHtml
          );
        const messageToSend = isHtmlMessage ? rawHtml : plainText;

        if (!messageToSend && files.length === 0) {
          addToast({
            title: intl.formatMessage({ id: 'MessageCannotBeEmpty' }),
            type: 'error',
          });
          return;
        }
        startLoading();
        // encrypt message before sending
        const message = isE2EEnabled
          ? await encryptChatMessage(messageToSend, conversationId.Guid)
          : messageToSend;

        const Attachments = [];
        if (files) {
          for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const result = await CreateAttachment({
              attachmentName: file.name,
              attachmentType: file.type,
            });

            if (result.CreateAttachmentResult) {
              const encryptedAttachment = isE2EEnabled
                ? await encryptAttachment(
                  file,
                  result.attachment.EncryptionKey,
                  result.attachment.Iv
                )
                : '';
              Attachments.push(result.attachment);
              try {
                const response = await UploadToAws({
                  file: isE2EEnabled ? encryptedAttachment : file,
                  attachmentGuid: result.attachment.Guid,
                });
              } catch (error) {
                addToast({
                  title: intl.formatMessage({ id: 'ErrorUploadingFile' }),
                  type: 'error',
                });
              }
            } else {
              addToast({
                title: intl.formatMessage({ id: 'MessageWasNotSent' }),
                type: 'error',
              });
            }
          }
        }

        if (selectedMessage) {
          console.log(selectedMessage);
          if (selectedMessage.action === 'reply') {
            const result = await ReplyMessage({
              messageGuid: selectedMessage.message.Guid,
              reply: message,
              isHtmlMessage,
              attachments: Attachments,
            });
            if (result.repliedMessage) {
              setSelectedMessage();
              if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
                setHasUpdate(hasUpdate === 0 ? 1 : 0);
              }
            }
          }
        } else {
          const isGroup = conversationId.isGroup;

          if (isConnected) {
            // Send message via SignalR when connected (Desktop logic)
            if (isGroup) {
              await sendMessageUsingFilter_SignalR({
                contactInformation: conversationId.Owner?.StaffGuid || conversationId.Owner,
                Message: message,
                IsHtmlMessage: isHtmlMessage,
                conversationGuid: conversationId.Guid,
                Attachments,
              });
            } else {
              await sendMessageUsingContactInformation_SignalR({
                contactInformation: conversationId.Owner,
                Message: message,
                IsHtmlMessage: isHtmlMessage,
                conversationGuid: conversationId.Guid,
                Attachments,
              });
            }
          } else {
            // Fallback to normal HTTP REST API when disconnected
            console.warn('[Chat] SignalR not connected. Falling back to HTTP API.');
            if (!isGroup) {
              await SendMessageUsingContactInformation({
                contactInformation: conversationId.Owner,
                Message: message,
                conversationGuid: conversationId.Guid,
                Attachments,
                IsPoll: false,
                IsHtmlMessage: isHtmlMessage,
              });
            } else {
              await SendMessageUsingFilter({
                conversationGuid: conversationId.Owner?.StaffGuid || conversationId.Owner,
                Message: message,
                Attachments,
                IsPoll: false,
                IsHtmlMessage: isHtmlMessage,
              });
            }
          }
        }

        inputSendText.current?.clearContent?.();
        setOpenEmoji(false);
        messagesEndRef.current?.scrollIntoView();

        // Only trigger manual update if SignalR is disconnected (HTTP fallback)
        if (!isConnected && REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
          setHasUpdate(hasUpdate == 0 ? 1 : 0);
        }

        setUnreadMessages([]);
        fileRef.current.value = null;
        setFiles([]);
        stopLoading();
      } catch (error) {
        stopLoading();
        console.log(error);
        addToast({
          title: intl.formatMessage({ id: 'MessageWasNotSent' }),
          type: 'error',
        });
      }
    },
    [
      conversationId.Guid,
      conversationId.Owner,
      conversationId.isGroup,
      files,
      hasUpdate,
      selectedMessage,
      startLoading,
      stopLoading,
      isConnected,
      sendMessageUsingContactInformation_SignalR,
      sendMessageUsingFilter_SignalR,
    ]
  );

  const onEmojiClick = (emojiData, event) => {
    event.preventDefault();
    if (inputSendText.current) {
      inputSendText.current.insertEmoji(emojiData.emoji);
      inputSendText.current.focus();
    }
  };

  const onClinkOpenEmojis = useCallback(() => {
    setOpenEmoji(!openEmoji);
  }, [openEmoji]);

  const scrollToBottomDirect = useCallback(() => {
    if (scroll.current) {
      scroll.current.scrollTop = scroll.current.scrollHeight;
    }
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
    }
  }, []);


  const scrollToBottom = useCallback(() => {
    setPastMessages([]);
    setLoadingMessages(false);
    setMoreMessagesAvailable(true);
    // Close any open edit box when conversation is selected/re-selected
    setEditingMessage(null);
    setEditExistingAttachments([]);

    requestAnimationFrame(scrollToBottomDirect);
    setTimeout(scrollToBottomDirect, 50);
    setTimeout(scrollToBottomDirect, 150);
    setTimeout(scrollToBottomDirect, 300);
  }, [scrollToBottomDirect]);

  const scrollSimple = useCallback(() => {
    setPastMessages([]);
    setMoreMessagesAvailable(true);
    setLoadingMessages(false);
    scrollToBottomDirect();
  }, [scrollToBottomDirect]);

  useEffect(() => {
    scrollToBottom();
  }, [conversationId]);

  // Automatically scroll to bottom when conversation loads OR when a NEW message arrives/sent (never on edits)
  useEffect(() => {
    // console.log("Total messages in chat window:", messages?.length || 0, messages);

    if (!messages || messages.length === 0) return;

    const currentLastMessage = messages[messages.length - 1];
    const currentLastGuid = currentLastMessage?.Guid;

    // If an edit was just saved, do NOT scroll
    if (isEditingSaveRef.current) {
      prevLastMessageGuidRef.current = currentLastGuid;
      return;
    }

    // 1. Initial conversation load -> ALWAYS scroll to bottom
    // 2. New message sent or received at the bottom -> scroll to bottom
    const isInitialLoad = !prevLastMessageGuidRef.current;
    const isNewBottomMessage =
      Boolean(prevLastMessageGuidRef.current) &&
      currentLastGuid !== prevLastMessageGuidRef.current;

    prevLastMessageGuidRef.current = currentLastGuid;

    if (isInitialLoad || isNewBottomMessage) {
      requestAnimationFrame(scrollToBottomDirect);
      setTimeout(scrollToBottomDirect, 50);
      setTimeout(scrollToBottomDirect, 150);
    }
  }, [messages, scrollToBottomDirect]);

  const scrollTo = (event) => {
    const scrollTop = event.target?.scrollTop || 0;
    setTopS(scrollTop);

    // Trigger load more when user actually scrolls up near the top (increased threshold to 150px)
    if (scrollTop < 150 && messages && messages.length > 0 && !loadingMessages && moreMessagesAvailable) {
      setMore(true);
    }
  };

  const scrollToMessage = (id) => {
    try {
      const div = document.getElementById(id);
      div.scrollIntoView();
    } catch (error) {
      console.log(error);
    }
  };

  // Load older messages into the single `messages` array when scrolled to top
  useEffect(() => {
    const getMoreMessages = async () => {
      if (isFetchingMoreRef.current) return;
      if (!messages || messages.length === 0 || !moreMessagesAvailable) return;
      const oldestMessage = messages[0];
      if (!oldestMessage?.Guid) return;

      isFetchingMoreRef.current = true;
      // Remember scroll height before inserting older messages to preserve exact scroll position
      const scrollEl = scroll.current;
      const prevScrollHeight = scrollEl ? scrollEl.scrollHeight : 0;

      setLoadingMessages(true);
      try {
        const response = await GetMessagesForConversations({
          Guid: oldestMessage.ConversationGuid || conversationId.Guid,
          indexMessageGuid: oldestMessage.Guid,
          maxNumberMessages: -20,
          conversationDecryptedKey,
          conversationDecryptedIV,
        });

        if (response?.GetMessagesForConversationResult) {
          setMoreMessagesAvailable(response.moreMessagesAvailable);
          const olderMessages = response.orderedMessages || [];

          if (olderMessages.length > 0) {
            // Find any unread messages among the loaded older messages
            const unreadOlder = olderMessages.filter(
              (message) =>
                !message.IsRead &&
                `${message.Sender?.StaffGuid}` !== `${userGuid}`
            );

            if (unreadOlder.length > 0) {
              const targetGuid = conversationId?.Guid || conversationId;
              if (signalRService.isConnected || signalRService.isStarting) {
                await markAllMessageRead_SignalR({
                  conversationGuid: targetGuid,
                });
              } else {
                await MarkAllMessageRead({
                  conversationGuid: targetGuid,
                });
              }
              // Mark as read in-memory
              unreadOlder.forEach((m) => {
                m.IsRead = true;
              });
              // Refresh sidebar conversations to decrease unread badge count
              await GetUserConversations();
            }

            // Prepend older messages directly to `messages`!
            setMessages((prev) => [...olderMessages, ...prev]);

            // Keep scroll position locked so view does not jump
            requestAnimationFrame(() => {
              if (scrollEl) {
                scrollEl.scrollTop = scrollEl.scrollHeight - prevScrollHeight;
              }
            });
          }
        }
      } catch (err) {
        console.error('Failed to load more messages:', err);
      } finally {
        setLoadingMessages(false);
        isFetchingMoreRef.current = false;
      }
    };

    if (more) {
      getMoreMessages();
    }
    setMore(false);
    }, [more, messages, moreMessagesAvailable, conversationId.Guid, setMessages, conversationDecryptedKey, conversationDecryptedIV, GetUserConversations]);

  const addPollMessage = useCallback(
    async (message) => {
      // encrypt message before sending
      // encrypt message before sending
      const pollMessage = isE2EEnabled
        ? await encryptChatMessage(message, conversationId.Guid)
        : message;

      // const message = await encryptChatMessage(message, conversationId.Guid);

      if (!conversationId.isGroup) {
        await SendMessageUsingContactInformation({
          contactInformation: conversationId.Owner,
          Message: pollMessage,
          conversationGuid: conversationId.Guid,
          IsPoll: true,
        });
      } else {
        const response = await SendMessageUsingFilter({
          conversationGuid: conversationId.Owner.StaffGuid,
          Message: pollMessage,
          IsPoll: true,
        });
      }
      if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
        //TODO: Need to remove
        setHasUpdate(hasUpdate === 0 ? 1 : 0);
      }
      setOpenPollDialog(false);
    },
    [conversationId]
  );

  const getMimeType = (attachmentType) => {
    switch (attachmentType) {
      case 0:
        return 'image/png';
      case 1:
        return 'image/jpeg'; // or detect exact format if needed
      case 10:
        return 'application/pdf';
      case 11:
        return 'text/plain';
      case 100:
        return 'application/octet-stream'; // fallback type for unknowns
      case 20:
        return 'video/mp4'; // or whatever format your videos are in
      default:
        return 'application/octet-stream'; // safe default
    }
  };

  const markedMessage = () => {
    const effectiveMsg =
      resolveForward(selectedMessage.message) || selectedMessage.message;
    const effectiveAttachments = effectiveMsg?.Attachments || [];
    const textToDisplay = effectiveMsg?.IsHtmlMessage
      ? getPlainMessageText(effectiveMsg?.Message)
      : effectiveMsg?.Message;

    return (
      <MessageContent>
        <MessageMarked>
          {effectiveAttachments && effectiveAttachments.length > 0 && (
            <AttachmentContainer>
              {effectiveAttachments.map((att, key) => {
                if (isE2EEnabled === 'true') {
                  const isEncrypted = att.EncryptionKey && att.Iv;
                  const handleAttachmentClick = async () => {
                    const mimeType = getMimeType(att.AttachmentType);
                    const decryptedUrl = await decryptAndCreateBlobUrl(
                      `${urlDownload}/${att.Guid}`,
                      att.EncryptionKey,
                      att.Iv,
                      mimeType,
                      att.Name
                    );
                  };
                  return (
                    <AttachmentFile key={key}>
                      {att &&
                        (att.AttachmentType === 0 ||
                          att.AttachmentType === 1) && (
                          <button onClick={handleAttachmentClick}>
                            <FaImage size={30} color="red" />
                            <p title={att.Name}>{att.Name}</p>
                          </button>
                        )}

                      {att && att.AttachmentType === 20 && (
                        <button onClick={handleAttachmentClick}>
                          <FaVideo size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                      {att && att.AttachmentType === 10 && (
                        <button onClick={handleAttachmentClick}>
                          <FaFilePdf size={30} color="red" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                      {att && att.AttachmentType === 11 && (
                        <button onClick={handleAttachmentClick}>
                          <FaFileAlt size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}

                      {att &&
                        att.AttachmentType !== 0 &&
                        att.AttachmentType !== 1 &&
                        att.AttachmentType !== 10 &&
                        att.AttachmentType !== 11 &&
                        att.AttachmentType !== 20 &&
                        att.AttachmentType !== 100 && (
                          <button onClick={handleAttachmentClick}>
                            <FaFileAlt size={30} color="#666" />
                            <p title={att.Name}>{att.Name}</p>
                          </button>
                        )}

                      {att && att.AttachmentType === 100 && (
                        <button onClick={handleAttachmentClick}>
                          <FaFile size={30} color="#333" />
                          <p title={att.Name}>{att.Name}</p>
                        </button>
                      )}
                    </AttachmentFile>
                  );
                } else {
                  return (
                    <AttachmentFile key={key}>
                      {att &&
                        (att.AttachmentType === 0 ||
                          att.AttachmentType === 1) && (
                          <img
                            alt={att.Name}
                            src={`${urlDownload}/${att.Guid}`}
                            onClick={() => setAttSeleted(att)}
                          />
                        )}
                      {att && att.AttachmentType === 20 && (
                        <video controls height="250" width="250">
                          <source src={`${urlDownload}/${att.Guid}`} />
                        </video>
                      )}

                      {att && att.AttachmentType === 10 && (
                        <a href={`${urlDownload}/${att.Guid}`} download>
                          <FaFilePdf size={30} color="red" />
                        </a>
                      )}
                      {att && att.AttachmentType === 11 && (
                        <a href={`${urlDownload}/${att.Guid}`} download>
                          <FaFileAlt size={30} color="#333" />
                        </a>
                      )}
                      {att && att.AttachmentType === 100 && (
                        <a href={`${urlDownload}/${att.Guid}`} download>
                          <FaFile size={30} color="#333" />
                        </a>
                      )}
                    </AttachmentFile>
                  );
                }
              })}
            </AttachmentContainer>
          )}

          {textToDisplay}
          <ButtonClose onClick={() => setSelectedMessage()}>
            <Close style={{ fontSize: 14 }} />
          </ButtonClose>
        </MessageMarked>
      </MessageContent>
    );
  };

  const handleAttachChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length > 0) {
      const existingFileNames = new Set(
        files.map((file) => file.name + file.size)
      );

      const newFiles = selectedFiles.filter(
        (file) => !existingFileNames.has(file.name + file.size)
      );

      if (newFiles.length === 0) {
        addToast({
          title: intl.formatMessage({ id: 'SelectedFilesAreAlreadyAttached' }),
          type: 'info',
        });
        return;
      }
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const removeFile = (fileToRemove) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file !== fileToRemove));
    fileRef.current.value = null;
  };

  const getImage = () => {
    const imageFiles = files.filter((file) => file.type.includes('image'));
    const otherFiles = files.filter((file) => !file.type.includes('image'));

    const renderFilePreview = (file) => {
      let icon = null;
      let color = '#333';
      let fileType = '';

      if (file.type === 'application/pdf') {
        icon = <FaFilePdf size={40} color="red" />;
        fileType = 'PDF';
      } else if (file.type === 'plain/txt') {
        icon = <FaFileAlt size={40} color="#666" />;
        fileType = 'Text';
      } else if (file.type.includes('video')) {
        icon = <FaFileVideo size={40} color="#666" />;
        fileType = 'Video';
      } else if (file.type.includes('audio')) {
        icon = <FaFileAudio size={40} color="#f777a0" />;
        fileType = 'Audio';
      } else {
        icon = <FaFile size={40} color="#333" />;
        fileType = 'File';
      }

      return (
        <div key={file.name} style={{ width: '140px' }}>
          <MessageContent>
            <MessageMarked style={{ height: 130 }}>
              {icon}
              <ButtonClose onClick={() => removeFile(file)}>
                <Close style={{ fontSize: 14 }} />
              </ButtonClose>
              <FileDetailsContainer>
                <FileName title={file.name}>{file.name}</FileName>
                <FileTypeSize>
                  {fileType} <span style={{ padding: '0px 2px' }}>|</span>{' '}
                  {(file.size / (1024 * 1024)).toFixed(2)} MB
                </FileTypeSize>
              </FileDetailsContainer>
            </MessageMarked>
          </MessageContent>
        </div>
      );
    };

    const renderImagePreview = (file) => {
      return (
        <div key={file.name} style={{ width: '140px' }}>
          <MessageContent>
            <MessageMarked style={{ height: 130 }}>
              <img
                src={URL.createObjectURL(file)}
                alt=""
                style={{ height: 100, width: 100 }}
              />
              <ButtonClose onClick={() => removeFile(file)}>
                <Close style={{ fontSize: 14 }} />
              </ButtonClose>
            </MessageMarked>
          </MessageContent>
        </div>
      );
    };

    return (
      <FilesPreviewContainer>
        {otherFiles.map((file, index) => renderFilePreview(file, index))}
        {imageFiles.map((file, index) => renderImagePreview(file, index))}
      </FilesPreviewContainer>
    );
  };

  useEffect(() => {
    if (selectedMessageForward) {
      setOpen(true);
    }
  }, [selectedMessageForward]);

  useEffect(() => {
    if (selectedMessage && selectedMessage.action === 'reply' && inputSendText.current) {
      inputSendText.current.focus();
    }
  }, [selectedMessage]);

  useEffect(() => {
    if (openEmoji) {
      scrollSimple();
    }
  }, [openEmoji, scrollSimple]);

  useEffect(() => {
    if (!refBottom.current) return;

    setPBottom((state) => refBottom.current?.clientHeight);
  }, [conversationId]);

  useEffect(() => {
    scrollToBottom();
  }, [pbottom]);

  const handleKeyDown = (event) => {
    if (event.which === 13 && !event.shiftKey) {
      // console.log(refBottom.current.clientHeight);
      submit();
      event.preventDefault();
    }
    if (event.which === 13 && event.shiftKey) {
      // event.preventDefault();
    }
  };

  useEffect(() => {
    if (attSelected) {
      setOpenDialog(true);
    }
  }, [attSelected]);

  const dispatchChangeEvent = () => {
    if (fileRef.current) {
      const event = new Event('change', { bubbles: true });
      fileRef.current.dispatchEvent(event);
    }
  };

  const onDrop = useCallback(async (acceptedFiles) => {
    if (fileRef.current) {
      const dataTransfer = new DataTransfer();
      acceptedFiles.forEach((file) => dataTransfer.items.add(file));
      fileRef.current.files = dataTransfer.files;

      dispatchChangeEvent();
    }
  }, []);

  const { getRootProps, isDragAccept, isDragReject, isDragActive } =
    useDropzone({
      onDrop,
      noClick: true,
    });

  const [showFormatToolbar, setShowFormatToolbar] = useState(false);
  const [groupMembers, setGroupMembers] = useState([]);

  // Load group members for @mentions
  useEffect(() => {
    let isMounted = true;
    const fetchGroupStaff = async () => {
      if (conversationId?.isGroup && conversationId?.Owner?.StaffGuid) {
        try {
          const res = await GetStaffInformationForStaffGroup({
            staffGroupGuid: conversationId.Owner.StaffGuid,
          });
          if (isMounted && res?.GetStaffInformationForStaffGroupResult) {
            setGroupMembers(res.staffContactInformationList || []);
          }
        } catch (e) {
          console.error('Failed to load group members for mentions:', e);
        }
      } else {
        setGroupMembers([]);
      }
    };
    fetchGroupStaff();
    return () => {
      isMounted = false;
    };
  }, [conversationId]);

  const mentionUsers = useMemo(() => {
    if (conversationId?.isGroup) {
      return [
        { StaffGuid: 'everyone', Name: 'Everyone' },
        ...(groupMembers || []),
      ];
    }
    return conversationId?.Owner ? [conversationId.Owner] : [];
  }, [conversationId, groupMembers]);

  useEffect(() => {
    if (selectedMessage && selectedMessage.action === 'edit') {
      setEditingMessage(selectedMessage.message);
      setEditExistingAttachments(selectedMessage.message?.Attachments || []);
      setSelectedMessage(null); // Clear selectedMessage so it doesn't open the reply preview
    }
  }, [selectedMessage]);

  const saveInlineEdit = async ({
    content,
    isHtmlMessage,
    newFiles,
    remainingExistingAttachments,
  }) => {
    if (!editingMessage) return;

    const isEmpty = !content?.trim();
    const hasAttachments =
      newFiles.length > 0 || remainingExistingAttachments.length > 0;

    if (isEmpty && !hasAttachments) {
      addToast({
        title: intl.formatMessage({ id: 'MessageCannotBeEmpty' }),
        type: 'error',
      });
      return;
    }

    try {
      startLoading();

      // 1. Upload & encrypt new files if any (same flow as sending attachments)
      const uploadedAttachments = [];
      if (newFiles && newFiles.length > 0) {
        for (let i = 0; i < newFiles.length; i++) {
          const file = newFiles[i];
          const result = await CreateAttachment({
            attachmentName: file.name,
            attachmentType: file.type,
          });

          if (result.CreateAttachmentResult) {
            const encryptedAttachment = isE2EEnabled
              ? await encryptAttachment(
                file,
                result.attachment.EncryptionKey,
                result.attachment.Iv
              )
              : '';
            uploadedAttachments.push(result.attachment);
            await UploadToAws({
              file: isE2EEnabled ? encryptedAttachment : file,
              attachmentGuid: result.attachment.Guid,
            });
          }
        }
      }

      // 2. Encrypt content if E2EE is enabled
      const finalContent = isE2EEnabled
        ? await encryptChatMessage(content, conversationId.Guid)
        : content;

      // 3. Construct updated staffMessage
      const staffMessage = {
        ...editingMessage,
        Message: finalContent,
        IsHtmlMessage: isHtmlMessage,
        Attachments: [...remainingExistingAttachments, ...uploadedAttachments],
      };

      // 4. Send UpdateMessage API
      const response = await UpdateMessage({ staffMessage });

      if (response?.UpdateMessageResult) {
        isEditingSaveRef.current = true; // 👈 Mark that this update is an edit
        // 5. Update message directly in local state with the READABLE content
        const localDisplayMessage = {
          ...staffMessage,
          Message: content,
          IsEdited: true,
        };
        setMessages((prev) =>
          prev.map((m) => (m.Guid === staffMessage.Guid ? localDisplayMessage : m))
        );
        // Clear edit flag after state settles
        setTimeout(() => {
          isEditingSaveRef.current = false;
        }, 2000);

        addToast({
          title: intl.formatMessage({ id: 'MessageUpdated', defaultMessage: 'Message updated' }),
          type: 'success',
        });
      }

      // Reset editing state
      setEditingMessage(null);
      setEditExistingAttachments([]);
      stopLoading();
    } catch (error) {
      stopLoading();
      console.error('Error saving edited message:', error);
      addToast({
        title: intl.formatMessage({ id: 'ErrorSavingMessage', defaultMessage: 'Failed to update message' }),
        type: 'error',
      });
    }
  };

  return (
    <>
      {isDragActive && (
        <DropArea
          {...getRootProps({ isDragAccept, isDragReject, isDragActive })}
        >
          <CloudUploadOutlinedIcon style={{ marginRight: '10px' }} />
          {isDragActive && !isDragReject && <p>Drop files here</p>}
          {isDragReject && <p>Some files will be rejected</p>}
        </DropArea>
      )}

      <Container
        {...getRootProps({ isDragAccept, isDragReject, isDragActive })}
      >
        <Content
          ref={scroll}
          onScroll={scrollTo}
          isMessageSelected={!!selectedMessage}
          isEmojisOpened={!!openEmoji}
        >
          {(loadingMessages || isLoading) && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 5,
                right: 0,
                display: 'flex',
                justifyContent: 'flex-start',
              }}
            >
              <LinearProgress
                color="secondary"
                variant="indeterminate"
                style={{ width: '100%' }}
              />
            </div>
          )}

          {messages.map((message) => {
            let formatedDate = '';
            const isDeleted =
              message.Message ===
              intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' });
            formatedDate = new Date(
              convertBackendDate(message.MessageDateTime)
            );

            const effectiveMsg = resolveForward(message) || message;
            let text = isDeleted
              ? intl.formatMessage({ id: 'ThisMessageHasBeenDeleted' })
              : effectiveMsg.Message || '';

            return (
              <React.Fragment key={message.Guid}>
                {unreadMessages.length > 0 &&
                  unreadMessages[0].Guid === message.Guid && (
                    <Unread key={unreadMessages[0].Guid}>
                      {intl.formatMessage({ id: 'UnreadMessages' })};
                    </Unread>
                  )}
                {editingMessage?.Guid === message.Guid ? (
                  <MessageEditTextarea
                    message={message}
                    mentionUsers={mentionUsers}
                    existingAttachments={editExistingAttachments}
                    onRemoveExistingAttachment={(guid) => {
                      setEditExistingAttachments((prev) =>
                        prev.filter((att) => att.Guid !== guid)
                      );
                    }}
                    onCancel={() => {
                      setEditingMessage(null);
                      setEditExistingAttachments([]);
                    }}
                    onSave={saveInlineEdit}
                  />
                ) : (
                  <BalloonComponent
                    selectedConversation = {conversationId}
                    scrollTo={scrollToMessage}
                    message={message}
                    messages ={messages}
                    text={text}
                    conversationId={conversationId}
                    isDeleted={isDeleted}
                    userGuid={userGuid}
                    formatedDate={formatedDate}
                    urlDowload={urlDownload}
                    setAttSeleted={setAttSeleted}
                    setSelectedMessage={setSelectedMessage}
                    setSelectedMessageForward={setSelectedMessageForward}
                    setOpen={setOpen}
                    decryptAndCreateBlobUrl={decryptAndCreateBlobUrl}
                  />
                )}
              </React.Fragment>
            );
          })}

          <div ref={messagesEndRef} />
        </Content>

        {scroll !== null &&
          scroll.current?.scrollHeight - scroll?.current?.scrollTop !==
          scroll.current?.clientHeight && (
            <ButtonScrollDown {...getRootProps({ isDragActive })}>
              <IconButton size="small" color="inherit" onClick={scrollSimple}>
                <FaChevronDown size={16} />
              </IconButton>
            </ButtonScrollDown>
          )}
      </Container>

      {(!conversationId.Broadcast || conversationId.Administrator) && (
        <BottomContent ref={refBottom}>
          {selectedMessage && markedMessage()}

          {files.length > 0 && getImage()}

          <span
            style={{ position: 'relative', display: 'block', width: '100%' }}
          >
            {openEmoji && (
              <div
                className="emoji-flyout-container"
                style={{
                  display: openEmoji ? 'block' : 'none',
                  position: 'absolute',
                  bottom: '0', // opens above the button
                  right: '0', // starts at the button and extends to the right
                  marginBottom: 8,
                  zIndex: 1000,
                }}
              >
                <MemoPicker
                  emojiStyle={EmojiStyle.NATIVE}
                  lazyLoadEmojis
                  onEmojiClick={onEmojiClick}
                />
              </div>
            )}
          </span>
          <SendContent
            ref={formRef}
            onSubmit={submit}
            style={{ display: 'flex', width: '100%', padding: '4px 0' }}
          >
            <TiptapEditor
              ref={inputSendText}
              placeholder={intl.formatMessage({ id: 'TypeMessage' })}
              mentionUsers={mentionUsers}
              disableMentions={!!conversationId?.Broadcast}
              showToolbar={showFormatToolbar}
              onCloseToolbar={() => setShowFormatToolbar(false)}
              onSubmit={() => submit()}
            >
              <div
                className="composer-bottom-row"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  type="button"
                  className={`action-icon-btn ${showFormatToolbar ? 'active-format' : ''
                    }`}
                  title="Text Formatting"
                  onClick={() => setShowFormatToolbar(!showFormatToolbar)}
                >
                  <FormatColorTextIcon />
                </button>

                <button
                  type="button"
                  className={`action-icon-btn ${openEmoji ? 'active-format' : ''
                    }`}
                  title={intl.formatMessage({
                    id: 'Emojis',
                    defaultMessage: 'Emojis',
                  })}
                  onClick={onClinkOpenEmojis}
                >
                  <InsertEmoticonIcon />
                </button>

                <label
                  className="action-icon-btn"
                  htmlFor="attach"
                  title={intl.formatMessage({
                    id: 'AttachFiles',
                    defaultMessage: 'Attach Files',
                  })}
                  style={{ cursor: 'pointer', margin: 0 }}
                >
                  <AttachFileIcon />
                  <input
                    ref={fileRef}
                    multiple
                    type="file"
                    id="attach"
                    style={{ display: 'none' }}
                    onChange={handleAttachChange}
                  />
                </label>

                <button
                  type="button"
                  className="action-icon-btn"
                  title={intl.formatMessage({
                    id: 'CreatePoll',
                    defaultMessage: 'Create Poll',
                  })}
                  onClick={() => setOpenPollDialog(true)}
                >
                  <PollOutlinedIcon style={{ fontSize: 20 }} />
                </button>

                <div className="action-divider" />

                <button
                  type="submit"
                  className="action-icon-btn"
                  title={intl.formatMessage({
                    id: 'Send',
                    defaultMessage: 'Send',
                  })}
                >
                  <SendIcon />
                </button>
              </div>
            </TiptapEditor>
          </SendContent>
        </BottomContent>
      )}

      <Forward
        open={open}
        message={selectedMessageForward}
        conversation={conversationId}
        handleClose={() => {
          setOpen(false);
          setSelectedMessageForward();
        }}
      />

      <DialogImage
        att={attSelected}
        open={openDialog}
        close={() => setOpenDialog(false)}
      />

      <CreatePollDialog
        handleCancel={() => setOpenPollDialog(false)}
        handleOk={addPollMessage}
        open={openPollDialog}
      />
    </>
  );
};
export default Chat;
